import Config from 'react-native-config';

const MEDICAL_DEVICE_UDI_FALLBACK = '(01)08052859050004';

export const MEDICAL_DEVICE_UDI = Config.MEDICAL_DEVICE_UDI || MEDICAL_DEVICE_UDI_FALLBACK;
